export enum StorageKeys {
  MobileHelpScreenShown = 'mobile-help-screen-shown',
  DesktopExploreButtonShown = 'desktop-explore-button-shown',
}
